<pagination-template #pagination="paginationApi" [id]="config.id" (pageChange)="pageChanged($event)" id="paginationControls"
  class="flex flex-column align-center">
  <li id="firstPageControl" (click)="first()" [class.is-disabled]="pagination.isFirstPage()">
    <!-- TEMPORARY FIX FOR SVG/USE ISSUES WE WERE SEEING -->
    <svg id="{{getCompositeArrowId('FirstPageArrow')}}" viewBox="0 0 100 103" version="1.1" xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink">
      <!-- Generator: Sketch 42 (36781) - http://www.bohemiancoding.com/sketch -->
      <title>First</title>
      <desc>Created with Sketch.</desc>
      <defs></defs>
      <g id="Page-1" stroke="none" stroke-width="1" style="fill:var(--color)">
        <g id="Artboard-2" transform="translate(-58.000000, -312.000000)">
          <g id="First"
            transform="translate(108.000000, 363.500000) rotate(-180.000000) translate(-108.000000, -363.500000) translate(58.000000, 312.000000)">
            <g id="np_arrow-down_806731_000000" transform="translate(-0.000000, 0.000000)">
              <g id="Group">
                <path
                  d="M87.613,2.496 C90.4489,-0.3399 95.0388,-0.3399 97.875,2.496 C100.7031,5.3241 100.707,9.9218 97.875,12.754 L55.129,55.504 C52.3009,58.336 47.7032,58.3321 44.871,55.500094 C42.039,52.668094 42.039,48.074294 44.867094,45.242094 L87.613,2.496 Z"
                  id="Shape"></path>
                <path
                  d="M2.125,12.758 C-0.707,9.926 -0.707,5.3322 2.128906,2.496 C4.960906,-0.3399 9.554706,-0.336 12.386906,2.499906 L55.132906,45.241906 C57.964906,48.077806 57.968806,52.667706 55.136813,55.503906 C52.304813,58.339806 47.711013,58.339806 44.874813,55.503906 L2.125,12.758 Z"
                  id="Shape"></path>
              </g>
            </g>
            <g id="np_arrow-down_806731_000000" transform="translate(-0.000000, 45.000000)">
              <g id="Group">
                <path
                  d="M87.613,2.496 C90.4489,-0.3399 95.0388,-0.3399 97.875,2.496 C100.7031,5.3241 100.707,9.9218 97.875,12.754 L55.129,55.504 C52.3009,58.336 47.7032,58.3321 44.871,55.500094 C42.039,52.668094 42.039,48.074294 44.867094,45.242094 L87.613,2.496 Z"
                  id="Shape"></path>
                <path
                  d="M2.125,12.758 C-0.707,9.926 -0.707,5.3322 2.128906,2.496 C4.960906,-0.3399 9.554706,-0.336 12.386906,2.499906 L55.132906,45.241906 C57.964906,48.077806 57.968806,52.667706 55.136813,55.503906 C52.304813,58.339806 47.711013,58.339806 44.874813,55.503906 L2.125,12.758 Z"
                  id="Shape"></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  </li>
  <li id="previousPageControl" (click)="previous()" [class.is-disabled]="pagination.isFirstPage()">
    <svg id="{{getCompositeArrowId('PreviousPageArrow')}}" viewBox="0 0 100 58" version="1.1" xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink">
      <!-- Generator: Sketch 42 (36781) - http://www.bohemiancoding.com/sketch -->
      <title>Previous</title>
      <desc>Created with Sketch.</desc>
      <defs></defs>
      <g id="Page-1" stroke="none" stroke-width="1" style="fill:var(--color)">
        <g id="Artboard-2" transform="translate(-58.000000, -455.000000)">
          <g id="Previous"
            transform="translate(108.000000, 484.000000) rotate(-180.000000) translate(-108.000000, -484.000000) translate(58.000000, 455.000000)">
            <g id="Group">
              <path
                d="M87.613,2.496 C90.4489,-0.3399 95.0388,-0.3399 97.875,2.496 C100.7031,5.3241 100.707,9.9218 97.875,12.754 L55.129,55.504 C52.3009,58.336 47.7032,58.3321 44.871,55.500094 C42.039,52.668094 42.039,48.074294 44.867094,45.242094 L87.613,2.496 Z"
                id="Shape"></path>
              <path
                d="M2.125,12.758 C-0.707,9.926 -0.707,5.3322 2.128906,2.496 C4.960906,-0.3399 9.554706,-0.336 12.386906,2.499906 L55.132906,45.241906 C57.964906,48.077806 57.968806,52.667706 55.136813,55.503906 C52.304813,58.339806 47.711013,58.339806 44.874813,55.503906 L2.125,12.758 Z"
                id="Shape"></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  </li>
  <li id="{{getCurrentPageId()}}" class="h5 col-11 center">
    {{ pagination.getCurrent() }} of {{ pagination.getLastPage() }}
  </li>
  <li id="nextPageControl" (click)="next()" [class.is-disabled]="pagination.isLastPage()">
    <svg id="{{getCompositeArrowId('NextPageArrow')}}" viewBox="0 0 100 58" version="1.1" xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink">
      <!-- Generator: Sketch 42 (36781) - http://www.bohemiancoding.com/sketch -->
      <title>Next</title>
      <desc>Created with Sketch.</desc>
      <defs></defs>
      <g id="Page-1" stroke="none" stroke-width="1" style="fill:var(--color)">
        <g id="Artboard-2" transform="translate(-58.000000, -565.000000)">
          <g id="Next" transform="translate(58.000000, 565.000000)">
            <g id="Group">
              <path
                d="M87.613,2.496 C90.4489,-0.3399 95.0388,-0.3399 97.875,2.496 C100.7031,5.3241 100.707,9.9218 97.875,12.754 L55.129,55.504 C52.3009,58.336 47.7032,58.3321 44.871,55.500094 C42.039,52.668094 42.039,48.074294 44.867094,45.242094 L87.613,2.496 Z"
                id="Shape"></path>
              <path
                d="M2.125,12.758 C-0.707,9.926 -0.707,5.3322 2.128906,2.496 C4.960906,-0.3399 9.554706,-0.336 12.386906,2.499906 L55.132906,45.241906 C57.964906,48.077806 57.968806,52.667706 55.136813,55.503906 C52.304813,58.339806 47.711013,58.339806 44.874813,55.503906 L2.125,12.758 Z"
                id="Shape"></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  </li>
  <li id="lastPageControl" (click)="last()" [class.is-disabled]="pagination.isLastPage()">
    <svg id="{{getCompositeArrowId('LastPageArrow')}}" viewBox="0 0 100 103" version="1.1" xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink">
      <!-- Generator: Sketch 42 (36781) - http://www.bohemiancoding.com/sketch -->
      <title>Last</title>
      <desc>Created with Sketch.</desc>
      <defs></defs>
      <g id="Page-1" stroke="none" stroke-width="1" style="fill:var(--color)">
        <g id="Artboard-2" transform="translate(-58.000000, -672.000000)">
          <g id="Last" transform="translate(58.000000, 672.000000)">
            <g id="np_arrow-down_806731_000000">
              <g id="Group">
                <path
                  d="M87.613,2.496 C90.4489,-0.3399 95.0388,-0.3399 97.875,2.496 C100.7031,5.3241 100.707,9.9218 97.875,12.754 L55.129,55.504 C52.3009,58.336 47.7032,58.3321 44.871,55.500094 C42.039,52.668094 42.039,48.074294 44.867094,45.242094 L87.613,2.496 Z"
                  id="Shape"></path>
                <path
                  d="M2.125,12.758 C-0.707,9.926 -0.707,5.3322 2.128906,2.496 C4.960906,-0.3399 9.554706,-0.336 12.386906,2.499906 L55.132906,45.241906 C57.964906,48.077806 57.968806,52.667706 55.136813,55.503906 C52.304813,58.339806 47.711013,58.339806 44.874813,55.503906 L2.125,12.758 Z"
                  id="Shape"></path>
              </g>
            </g>
            <g id="np_arrow-down_806731_000000" transform="translate(0.000000, 45.000000)">
              <g id="Group">
                <path
                  d="M87.613,2.496 C90.4489,-0.3399 95.0388,-0.3399 97.875,2.496 C100.7031,5.3241 100.707,9.9218 97.875,12.754 L55.129,55.504 C52.3009,58.336 47.7032,58.3321 44.871,55.500094 C42.039,52.668094 42.039,48.074294 44.867094,45.242094 L87.613,2.496 Z"
                  id="Shape"></path>
                <path
                  d="M2.125,12.758 C-0.707,9.926 -0.707,5.3322 2.128906,2.496 C4.960906,-0.3399 9.554706,-0.336 12.386906,2.499906 L55.132906,45.241906 C57.964906,48.077806 57.968806,52.667706 55.136813,55.503906 C52.304813,58.339806 47.711013,58.339806 44.874813,55.503906 L2.125,12.758 Z"
                  id="Shape"></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  </li>
</pagination-template>